/* eslint-disable react/jsx-no-target-blank */
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import MillesimaLink from '@/components/common/MillesimaLink';
import { PAGES } from '@/constants/pages';
import { normalizeUrl } from '@/utils/menuUtils';

export const getLinksElement = (element) => element?.filter(Boolean).map((elem, key) => <LinkElement key={key} elem={elem} />);

const LinkElement = ({ elem }) => {
	const router = useRouter();

	if (elem) {
		const { name, isTargetBlank } = elem;
		const url = normalizeUrl(elem.url);
		let isNofollow;

		if (router.pathname === PAGES.HOME) {
			isNofollow = elem.isNofollow;
		} else {
			isNofollow = elem.isNofollowExclHome;
		}

		return (
			<li>
				<MillesimaLink
					href={url}
					isNofollow={isNofollow}
					forceReload={elem.hasJsScript}
					title={name}
					isTargetBlank={isTargetBlank}
					ariaLabel={name}
					type="inline-link"
				>
					{name}
				</MillesimaLink>
			</li>
		);
	}

	return null;
};

LinkElement.propTypes = {
	elem: PropTypes.shape({
		url: PropTypes.string,
		name: PropTypes.string,
		isNofollow: PropTypes.bool,
		isNofollowExclHome: PropTypes.bool,
		isTargetBlank: PropTypes.bool,
		hasJsScript: PropTypes.bool,
	}),
};

export default LinkElement;
